import CoreComponent from '../../core/CoreComponent.vue';
import CIAMLogin from '../../ui/ciamLogin/ciamLogin.vue';
import store from '@/store';
export default {
  extends: CoreComponent,
  components: {
    CIAMLogin
  },
  store: store,
  data() {
    return {
      showForm: true
    };
  },
  computed: {
    reauthorizationRequired() {
      return this.$store.state?.user?.reauthorizationRequired;
    },
    termsAccepted() {
      return this.$store.state.user.termsAccepted;
    },
    isModal() {
      return document.getElementById(this.cmpId).dataset.ismodal;
    },
    selectorCIAMLogin() {
      return `#${this.cmpId} [data-ciam-login]`;
    },
    isAuthenticated() {
      return this.$store.state?.user?.isAuthenticated;
    },
    isRedirecting() {
      return this.$store.state?.user?.redirecting;
    }
  },
  methods: {},
  created() {},
  watch: {}
};